// extracted by mini-css-extract-plugin
export default {"cont":"Ai_cont__Muu4v"};